import { CommonModule } from '@angular/common';
import type { ElementRef } from '@angular/core';
import { ChangeDetectorRef, Component, Input, ViewChild, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import { AssignedLocationsInfoContainerComponent } from '@core/locations-smart-ui';
import type { OfferStatus } from '@core/offers-types';
import { OfferStatusComponent } from '@core/offers-ui';
import {
  BadgeComponent,
  BoxComponent,
  ButtonComponent,
  ClickToCopyDirective,
  DividerComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

export type RequisitionsJobItem = {
  id: number;
  guid: string;
  status: OfferStatus;
  title: string;
  url: string;
  department: string | null;
  location: string;
  locationIds?: number[];
  lastActivityAt: string;
  qualifiedCount: number;
  hiredCount: number;
  disqualifiedCount: number;
};

@Component({
  selector: 'rt-requisitions-job-item',
  templateUrl: './requisitions-job-item.component.html',
  styleUrls: ['./requisitions-job-item.component.less'],
  imports: [
    BadgeComponent,
    BoxComponent,
    ClickToCopyDirective,
    CommonModule,
    DividerComponent,
    HeadingComponent,
    IconComponent,
    OfferStatusComponent,
    RouterModule,
    RtTooltip,
    TranslatePipe,
    ButtonComponent,
    AssignedLocationsInfoContainerComponent,
  ],
})
export class RequisitionsJobItemComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  @Input() public item: RequisitionsJobItem;

  public departmentLabelTooltipEnabled = false;

  @ViewChild('departmentRef') public set departmentRef(departmentRef: ElementRef) {
    if (departmentRef) this.setDepartmentTooltipEnabled(departmentRef);
  }

  private setDepartmentTooltipEnabled(departmentRef: ElementRef) {
    this.departmentLabelTooltipEnabled =
      departmentRef.nativeElement.offsetWidth < departmentRef.nativeElement.scrollWidth;
    this.cdRef.detectChanges();
  }
}
